import { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation } from "react-router";

import { Loader } from "@/atoms";
import { routesUrlsData, sidebarTabsData } from "@/data";
import { AuthProvider } from "@/providers";
import { setSidebarActiveTab } from "@/redux/actions";

export const RootLayout = () => {
    const dispatch = useDispatch();

    const location = useLocation();

    useEffect(
        () => {
            const activeTab = sidebarTabsData[location.pathname];

            dispatch(setSidebarActiveTab(activeTab));
        },
        [dispatch, location],
    );

    useEffect(
        () => {
            if (location.pathname === "/") window.location.pathname = routesUrlsData.events.url;
        },
        [location],
    );

    return (
        <AuthProvider>
            <Suspense fallback={<Loader />}>
                <Outlet />
            </Suspense>
        </AuthProvider>
    );
};
